<template>
  <section id="carousel" class="carousel" aria-roledescription="carousel" aria-label="Media Carousel">
    <button v-if="shouldShowPrev" @click="prevItem" class="arrow prev main-background" aria-label="Previous picture" aria-controls="carousel-items"></button>
    <div
      class="slide-container"
      v-for="(item, idx) in knownMedia"
      :key="item.id"
      :class="{ 'active': active === idx }"
      role="group"
      aria-roledescription="slide"
      :aria-label="idx+1 + ' of ' + knownMedia.length">
      <div class="slide" v-if="item.type === 'image'" @click="openPopup($event, idx)" @keypress="openPopup($event, idx)" tabindex="0" role="button">
        <i class="zoom-icon material-icons" aria-hidden="true">zoom_in</i>
        <img :src="item.file.url" v-if="item.settings && item.settings.position" :style="{ objectPosition: item.settings.position }" :alt="item.settings.description" crossorigin="anonymous">
        <img :src="item.file.url" v-else alt="" crossorigin="anonymous">
      </div>
      <div class="slide" v-else-if="item.type === 'video'" @click="openPopup($event, idx)" @keypress="openPopup($event, idx)" tabindex="0" role="button">
        <div role="presentation" class="click-interceptor">
        </div>
        <vue-video-player class="video-player-container"
                 ref="videoPlayer"
                 :options="{
                   muted: muted,
                   height: 150,
                   responsive: true,
                   controls: true,
                   sources: [{
                     type: 'video/mp4',
                     src: item.job.outputs.length > 0 ? item.job.outputs[0].resultUrl : ''
                   }]}"
                 :playsinline="true"/>
      </div>
      <div class="slide" v-else-if="item.type === 'image_360'" @click="openPopup($event, idx)" @keypress="openPopup($event, idx)" tabindex="0" role="button">
        <panorama :source="item.file.url" :settings="item.settings"/>
      </div>
      <div class="slide" v-else-if="item.type === '3d_link'" @click="openPopup($event, idx)" @keypress="openPopup($event, idx)" tabindex="0" role="button">
        <iframe allowfullscreen :src="item.settings.url" frameborder="0"></iframe>
      </div>
    </div>
    <button v-if="shouldShowNext" @click="nextItem" class="arrow next main-background" aria-label="Next picture" aria-controls="carousel-items"></button>
    <popup-view
      v-if="previewPopup"
      v-on:close-popup="previewPopup = $event"
      :videoCC='getVideoCC'
      :transcript="transcript"
      :list="knownMedia"
      :index="previewIndex"></popup-view>
  </section>
</template>

<script>
// import Panorama from './PoiPano'
import PopupView from './PopupView'
import 'video.js/dist/video-js.css'
// import { videoPlayer } from 'vue-video-player'
export default {
  name: 'PoiMediaSlider',
  components: {
    'popupView': PopupView,
    // 'panorama': Panorama,
    // 'vue-video-player': videoPlayer
    'panorama': () => import(/* webpackChunkName: "panorama" */ './PoiPano'),
    'vue-video-player': () => import(/* webpackChunkName: "videojs" */ 'vue-video-player').then((res) => res.videoPlayer)
  },
  props: {
    'mediaList': {
      type: Array,
      default: () => []
    },
    transcript: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      active: 0,
      previewPopup: false,
      previewIndex: 0
    }
  },
  methods: {
    nextItem: function () {
      if (this.shouldShowNext) this.active += 1
    },
    prevItem: function () {
      if (this.shouldShowPrev) this.active -= 1
    },
    openPopup: function (event, index) {
      if (event.target.classList.contains('vjs-big-play-button')) return
      this.previewIndex = index
      this.previewPopup = true
    }
  },
  computed: {
    muted: function () {
      if (this.$store.state.college.settings.video_settings === undefined ||
          this.$store.state.college.settings.video_settings.muted === undefined) {
        return true
      } else {
        return this.$store.state.college.settings.video_settings.muted
      }
    },
    shouldShowPrev: function () {
      return this.active > 0
    },
    shouldShowNext: function () {
      return this.active < this.knownMedia.length - 1
    },
    getVideoCC: function () {
      return this.mediaList.filter(item => {
        if (item.type === 'video_cc') { return item }
      })
    },
    knownMedia: function () {
      let priorityItems = {
        'video': 1,
        'image_360': 2,
        '3d_link': 3,
        'image': 4
      }
      let filteredArr = this.mediaList.filter(function (item) {
        return (
          (item.type === 'image' && item.file) ||
          (item.type === 'video' && item.job && item.job.outputs.length > 0) ||
          (item.type === 'image_360' && item.file) ||
          (item.type === '3d_link' && item.settings.url)
        )
      })
      return filteredArr.sort((a, b) => {
        if (a.type === 'image' && b.type === 'image') {
          if (a.settings && a.settings.order) {
            if (b.settings && b.settings.order) {
              return a.settings.order - b.settings.order
            } else {
              return 1
            }
          } else if (b.settings && b.settings.order) {
            return -1
          } else {
            return 0
          }
        } else {
          return priorityItems[a.type] - priorityItems[b.type]
        }
      })
    }
  },
  watch: {
    $route (to, from) {
      this.active = 0
    }
  }
}
</script>
